// UX45: per-poll activity derivation for the social-proof chip.
//
// Pulls from the existing voteIndex ({ [pollId]: { [pubkey]: { createdAt, ... } } })
// and summarises recent activity so the UI can show "🔥 Trending",
// "⚡ N today", etc. No new storage, no network — the voteIndex is
// already live from the vote subscription.
//
// Returned shape per poll:
//   { last24h: number, lastHour: number, trending: boolean }
//
// trending = at least 3 votes in the last hour AND at least 60% of the
// 24h volume landed in the last hour (sudden spike). That's a soft
// heuristic — the chip's job is "feels alive", not statistical rigor.

const HOUR = 60 * 60
const DAY = 24 * HOUR

export function buildActivityIndex(voteIndex) {
  if (!voteIndex) return {}
  const now = Math.floor(Date.now() / 1000)
  const out = {}
  for (const [pollId, byVoter] of Object.entries(voteIndex)) {
    let last24h = 0
    let lastHour = 0
    for (const row of Object.values(byVoter)) {
      const dt = now - (row.createdAt || 0)
      if (dt < 0) continue
      if (dt <= DAY) last24h += 1
      if (dt <= HOUR) lastHour += 1
    }
    const trending = lastHour >= 3 && last24h > 0 && (lastHour / last24h) >= 0.6
    out[pollId] = { last24h, lastHour, trending }
  }
  return out
}
